<div class="grid">
    <div class="col-12">
        <p-card>
            <div class="grid">
                <!-- Map Section -->
                <div class="col-12 lg:col-4 map-sticky-container">
                    <div class="map-sticky-wrapper">
                        <div class="flex flex-column gap-2 my-2 map-container">
                            <div style="position: relative; height: 100%;">
                                <div #map class="site-map" style="height: 100%;"></div>
                                <div *ngIf="!chargementCompleteMap"
                                    style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                                    <p-progressSpinner></p-progressSpinner>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Table Section -->
                <div class="col-12 lg:col-8">
                    <div class="mb-4">
                        <h5 class="my-1">Emplacements</h5>
                        <span class="text-500">Vous trouverez ici la liste des emplacements (chantiers, entrepôts,
                            etc.).</span>
                    </div>
                    <div class="flex align-content-center justify-content-between gap-2 flex-wrap my-2">
                        <div class="flex align-items-center gap-2 flex-wrap">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input #champRecherche autofocus pInputText type="text"
                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    (keyup.enter)="surEntreeRecherche()" placeholder="Recherche..." />
                            </span>
                            <button *ngIf="estAutorise('emplacement_creer')" pButton pRipple icon="pi pi-plus"
                                class="p-button-success" label="Ajouter" (click)="surAjoutEmplacement()"></button>
                        </div>
                        <div>
                            <p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
                                placeholder="Colonnes..."></p-multiSelect>
                        </div>
                    </div>
                    <p-table #dt [value]="emplacements" dataKey="emplacementId" tableStyleClass="tableNormale"
                        autoLayout="true" styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true"
                        [filterDelay]="0" [globalFilterFields]="['nom','description','code']">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="code">
                                    <div class="flex justify-content-between align-items-center">
                                        Code
                                        <p-sortIcon field="code"></p-sortIcon>
                                        <p-columnFilter type="text" field="code" display="menu" class="ml-auto">
                                        </p-columnFilter>
                                    </div>
                                </th>
                                <th pSortableColumn="nom">
                                    <div class="flex justify-content-between align-items-center">
                                        Nom
                                        <p-sortIcon field="nom"></p-sortIcon>
                                        <p-columnFilter type="text" field="nom" display="menu" class="ml-auto">
                                        </p-columnFilter>
                                    </div>
                                </th>
                                <th>
                                    <div class="flex justify-content-between align-items-center">
                                        <span class="flex align-items-center gap-1">Départ <i class="pi pi-info-circle"
                                                pTooltip="Sera utilisé comme emplacement de départ pour les réquisitions, comme emplacement de d'arrivée pour les retours et ne sera pas disponible pour les transferts"
                                                [tooltipPosition]="'bottom'"></i></span>
                                        <p-columnFilter type="boolean" field="indDepart" display="menu" class="ml-auto">
                                        </p-columnFilter>
                                    </div>
                                </th>
                                <th pSortableColumn="statut.nom">
                                    <div class="flex justify-content-between align-items-center">
                                        Statut
                                        <p-sortIcon field="statut.nom"></p-sortIcon>
                                        <p-columnFilter type="text" field="statut.nom" display="menu" class="ml-auto">
                                        </p-columnFilter>
                                    </div>
                                </th>

                                <th style="min-width: 5rem; width: 5rem"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-emplacement>
                            <tr [pContextMenuRow]="liste" (mouseenter)="onRowHover(emplacement)">
                                <td>
                                    <a *ngIf="estAutorise('emplacement_detail')"
                                        [routerLink]="'/emplacement/' + emplacement.emplacementId">{{emplacement.code}}</a>
                                    <span *ngIf="!estAutorise('emplacement_detail')">{{emplacement.code}}</span>

                                </td>
                                <td>{{emplacement.nom}}</td>
                                <td>
                                    <div *ngIf="emplacement.indDepart"
                                        class="flex justify-content-center align-items-center gap-1">
                                        <i class="pi pi-check" style="color: var(--green-500);"></i>
                                        <span>Oui</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="flex flex-column align-items-center gap-2">
                                        <span
                                            [class]="'statut ' + emplacement.statut.nom.replace(' ','').toLowerCase()">
                                            {{emplacement.statut.nom}}
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <p-buttonGroup>
                                        <p-button icon="pi pi-eye" severity="success" size="small"
                                            [routerLink]="['/emplacement', emplacement.emplacementId]"></p-button>
                                    </p-buttonGroup>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="4">Aucun emplacement.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-card>
    </div>


</div>

<p-dialog [(visible)]="dialogueNouvelEmplacement" [style]="{width: '85%'}" header="Nouvel emplacement" [modal]="true"
    styleClass="fluid formgrid grid">
    <ng-template pTemplate="content">

        <p-toast key="nouvelEmplacement"></p-toast>

        <div class="formgrid grid">
            <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
                <label for="code">Code<span class="requis">*</span></label>
                <input type="text" pInputText id="code" [(ngModel)]="nouvelEmplacement.code" autocomplete="off" />
                <small class="p-error" *ngIf="submitted && !nouvelEmplacement.code">Le code est obligatoire.</small>
            </div>
            <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-6">
                <label for="nom">Nom<span class="requis">*</span></label>
                <input type="text" pInputText id="nom" [(ngModel)]="nouvelEmplacement.nom" autocomplete="off" />
                <small class="p-error" *ngIf="submitted && !nouvelEmplacement.nom">Le nom est obligatoire.</small>
            </div>

        </div>

    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Annuler" icon="pi pi-times" class="p-button-text"
            (click)="annulerNouvelEmplacement()"></button>
        <button pButton pRipple label="Créer" icon="pi pi-check" class="p-button-text"
            (click)="creerNouvelEmplacement()"></button>
    </ng-template>
</p-dialog>